import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { NamespaceView } from '@core/models/namespaceView.interface';

export enum INIT_STATUS {
  IN_PROGRESS = 'in_progress',
  RESOLVED = 'resolved',
  REJECTED = 'rejected',
}

@Injectable({
  providedIn: 'root'
})
export class NamespaceInitService {

  constructor(private apiService: ApiService) { }

  initNamespaceByDomain(domain: string): Observable<NamespaceView> {
    const initUrl = `${environment.api_url}/admin/init/${domain}`;
    return this.apiService.getFromThirdPartyUrl(initUrl);
  }

  setThemeLink(themeValue: string | null): void {
    if (!themeValue) return;

    const themeLink = document.getElementById('theme-stylesheet') as HTMLLinkElement;
    if (themeLink) {
      themeLink.href = `assets/css/theme-${themeValue}.css`;
    }
  }

}
